import { z } from 'zod';

export const nameValidation = (field: string) =>
  z
    .string()
    .min(2, { message: `${field} must have at least 2 characters.` })
    .max(50, { message: `${field} cannot exceed 50 characters.` })
    .refine((value) => /^[a-zA-ZñÑ\s]+$/.test(value), {
      message: `${field} should only contain letters.`,
    })
    .refine((value) => value.replace(/\s/g, '').length >= 2, {
      message: `${field} must have at least 2 characters.`,
    });

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
